// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smallModalCorporateSession {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: 0px;
  z-index: 999;
}

.smallModal {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  position: relative;
  flex-direction: column;
  max-width: 378px;
  min-width: 270px;
  min-height: 150px;
  background-color: white;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 999;
  text-align: start;
  border-top: 6px solid #007bc0;
}

.titleSmallModal {
  font-size: 16px;
  font-weight: 600;
}

.buttonsEdit {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 15px;
  margin-bottom: 15px;
  gap: 25px;
}

.containerTitleSmallModal {
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #c1c7cc;
}

.containerDescription {
  padding: 5px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bodySmallModal {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  font-size: 15px;
  margin-top: 25px;
}

button .buttonGeneric .buttonHover:hover {
  background-color: #00629a;
  color: #fff;
}

button.buttonGeneric.buttonHover {
  background-color: #007bc0;
  color: #fff;
}

.lineLabelSmallInput {
  margin-bottom: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/EditUserComponent/smallModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".smallModalCorporateSession {\n  display: flex;\n  position: fixed;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-left: 0px;\n  z-index: 999;\n}\n\n.smallModal {\n  display: flex;\n  justify-content: center;\n  /* align-items: center; */\n  position: relative;\n  flex-direction: column;\n  max-width: 378px;\n  min-width: 270px;\n  min-height: 150px;\n  background-color: white;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  z-index: 999;\n  text-align: start;\n  border-top: 6px solid #007bc0;\n}\n\n.titleSmallModal {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.buttonsEdit {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-top: 15px;\n  margin-bottom: 15px;\n  gap: 25px;\n}\n\n.containerTitleSmallModal {\n  padding: 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #c1c7cc;\n}\n\n.containerDescription {\n  padding: 5px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.bodySmallModal {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  font-size: 15px;\n  margin-top: 25px;\n}\n\nbutton .buttonGeneric .buttonHover:hover {\n  background-color: #00629a;\n  color: #fff;\n}\n\nbutton.buttonGeneric.buttonHover {\n  background-color: #007bc0;\n  color: #fff;\n}\n\n.lineLabelSmallInput {\n  margin-bottom: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
